import { AccountsService, IAccount } from "../../services";
import * as moment from "moment";
import env from "../../config";

class ReportsLegerController implements ng.IComponentController {
    from: Date;
    till: Date;
    accounts: IAccount[] = [];
    selectedAccountIds: string[] = [];
    rows: any[] = [];
    loading = false;

    constructor(
        private AccountsService: AccountsService,
        private $http: ng.IHttpService,
        private localStorageService: ng.local.storage.ILocalStorageService,
        private $timeout: ng.ITimeoutService,
        private FileSaver: ng.FileSaver
    ) {
        'ngInject';
    }

    $onInit = () => {
        this.from = moment().startOf('quarter').toDate();
        this.till = moment().endOf('quarter').toDate();
        this.AccountsService.all().then((result) => {
            this.accounts = (result || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            this.$timeout(() => {
                if ((<any>window).jQuery && (<any>window).jQuery.fn.chosen) {
                    (<any>window).jQuery('select[name="accountIds"]').trigger('chosen:updated');
                }
            }, 0);
        });
    }

    private buildAccountQueryParts = (): string[] => {
        return (this.selectedAccountIds || []).map(id => `accountIds=${encodeURIComponent(id)}`);
    }

    search = () => {
        this.loading = true;
        const from = moment(this.from).format('YYYY-MM-DD');
        const till = moment(this.till).format('YYYY-MM-DD');
        const queryParts = [
            `from=${encodeURIComponent(from)}`,
            `till=${encodeURIComponent(till)}`,
            ...this.buildAccountQueryParts()
        ];
        const token = this.localStorageService.get("authorizationData");
        const headers: any = {};
        if (token) {
            headers.Authorization = 'Bearer ' + token;
        }

        this.$http.get(`${env.API_URL}rapportage/leger?${queryParts.join('&')}`, { headers })
            .then((response: any) => {
                this.rows = response.data || [];
            })
            .finally(() => {
                this.loading = false;
            });
    }

    exportExcel = () => {
        if (!this.from || !this.till) {
            return;
        }

        const queryParts = [
            `from=${encodeURIComponent(moment(this.from).format('YYYY-MM-DD'))}`,
            `till=${encodeURIComponent(moment(this.till).format('YYYY-MM-DD'))}`,
            ...this.buildAccountQueryParts()
        ];

        const downloadUrl = `${env.API_URL}rapportage/leger/kwartaal?${queryParts.join('&')}`;
        const token = this.localStorageService.get("authorizationData");
        const headers: any = {};
        if (token) {
            headers.Authorization = 'Bearer ' + token;
        }

        this.$http.get(downloadUrl, { responseType: 'arraybuffer', headers }).then((response: any) => {
            const contentType = response.headers('Content-Type') || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            const contentDisposition = response.headers('Content-Disposition') || '';
            const filenameMatch = /filename\*?=(?:UTF-8''|")?([^\";]+)/i.exec(contentDisposition);
            let fileName = `kwartaalrapportage_${moment(this.from).format('YYYYMMDD')}_${moment(this.till).format('YYYYMMDD')}.xlsx`;

            if (filenameMatch && filenameMatch[1]) {
                fileName = decodeURIComponent(filenameMatch[1].replace(/"/g, ''));
            }

            const blob = new Blob([response.data], { type: contentType });
            this.FileSaver.saveAs(blob, fileName);
        });
    }
}

export const reportsLegerComponent: ng.IComponentOptions = {
    controller: ReportsLegerController,
    template: require('./reportsLeger.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/reports/reportsLeger.component.ts